import { createFileRoute } from '@tanstack/react-router'
import { DashboardAuthGate } from '~/features/auth/dashboard-auth-gate'
import {
  ProfileSetupPage,
  type SetupKind,
} from '~/features/profile-setup/components/profile-setup-page'

const isKind = (value: unknown): value is SetupKind => value === 'place' || value === 'organizer'

export const Route = createFileRoute('/setup/profile')({
  validateSearch: (search: Record<string, unknown>): { kind?: SetupKind; manual?: true } => ({
    kind: isKind(search.kind) ? search.kind : undefined,
    manual: search.manual === true || search.manual === 'true' ? true : undefined,
  }),
  component: SetupProfileRoute,
})

function SetupProfileRoute() {
  const { kind, manual } = Route.useSearch()
  return (
    <DashboardAuthGate>
      <ProfileSetupPage key={`${kind}-${manual}`} kind={kind} manual={manual} />
    </DashboardAuthGate>
  )
}
